<template>
  <Header />
  <main>

    <WelcomeBoard />

    <div class="album py-4 bg-body-tertiary">
      <div class="container">
        <VideoCards />
      </div>
    </div>

  </main>
  <Footer />
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import VideoCards from './components/VideoCards.vue'
import WelcomeBoard from './components/WelcomeBoard.vue'

export default {
  name: 'App',
  components: {
    Header,
    WelcomeBoard,
    Footer,
    VideoCards
  }
}
</script>

<style></style>
